import { render } from "./Link.vue?vue&type=template&id=24919e5b&scoped=true&lang=pug"
import script from "./Link.vue?vue&type=script&setup=true&lang=js"
export * from "./Link.vue?vue&type=script&setup=true&lang=js"

import "./Link.vue?vue&type=style&index=0&id=24919e5b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24919e5b"]])

export default __exports__